import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Container,
  Typography,
  Box,
  Button,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const AddRole = () => {
  const navigate = useNavigate();
  const [rolename, setRolename] = useState("");
  const [roles, setRoles] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const rolesRes = await axios.get(`${baseUrl}/api/roles`, {
          signal,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setRoles(rolesRes.data);
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Request was cancelled:", error.message);
        } else {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [baseUrl]);

  const validateForm = () => {
    if (!rolename.trim()) {
      alert("Role name is required.");
      return false;
    }
    const existingRole = roles.find(
      (role) => role.name.toLowerCase() === rolename.toLowerCase(),
    );
    if (existingRole) {
      alert("Role already exists. Please choose a different name.");
      return false;
    }
    return true;
  };

  const handleAddRole = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const token = localStorage.getItem("token");
        await axios.post(
          `${baseUrl}/api/roles`,
          {
            name: rolename,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert("Role added successfully");
        navigate("/dashboard/roles");
      } catch (error) {
        console.error("Error adding role:", error);
        if (error.response) {
          console.error("Error response:", error.response.data);
          alert(error.response.data.error || "Role addition failed");
        } else {
          alert("Role addition failed");
        }
      }
    }
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" component="h1" sx={{ mt: 2 }} gutterBottom>
        Add Role
      </Typography>
      <form onSubmit={handleAddRole}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Role Name"
              variant="outlined"
              value={rolename}
              onChange={(e) => setRolename(e.target.value)}
              required
              inputProps={{ id: "roleName" }}
            />
          </Grid>
        </Grid>
        <Box item xs={12} sx={{ mt: 3 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ width: "32.5%" }}
          >
            Add Role
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default AddRole;
